module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.5ede9ef5.ttf";